import { useInfiniteQuery } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { AIActionSkipsResponseDto } from '@/Domain/api/Action/dto/Action.dto';

const PAGE_SIZE = 10;

export const useActionSkips = (actionId: number) =>
  useInfiniteQuery<AIActionSkipsResponseDto>({
    queryKey: [QueryKey.actions.basic.skips, actionId],
    getNextPageParam: (lastPage, pages) =>
      lastPage.has_more ? { limit: PAGE_SIZE, offset: pages.length * PAGE_SIZE } : undefined,
    initialPageParam: { limit: PAGE_SIZE, offset: 0 },
  });
